import styled from 'styled-components';

export const MenuItem = styled.li`
  padding: 0;
  background: ${(props) => (props.color ? props.color : 'transparent')};
  transition: 0.3s;

  &:hover {
    background: ${(props) => props.hover};
  }
  &.about-li {
    list-style: none;
    background: transparent;
    &:hover {
      background: #f0f0f0;
      .about_menu {
        color: #000;
      }
    }
  }
`;
